import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import {
  DecryptString,
  EncryptString,
} from "@app/modules/shared/services/crypto-js.service";
import { environment } from "@env/environment";
import { Router } from "@angular/router";
import { Guid } from "guid-typescript";

declare const JSZip;

@Injectable()
export class UtilService {
  rolePermission: any;
  userRole: any;

  static encryptString(value) {
    if (value) {
      return EncryptString(value, environment.cryptoKey);
    } else {
      return "";
    }
  }

  static decryptString(value) {
    if (value) {
      return DecryptString(value, environment.cryptoKey);
    } else {
      return "";
    }
  }

  static toIntExt(value) {
    if (value !== null) {
      if (typeof value === "string") {
        return parseInt(value);
      } else if (typeof value === "number") {
        return value;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  static deepCopy<T>(source: T): T {
    if (source === undefined) {
      return null;
    } else {
      return JSON.parse(JSON.stringify(source));
    }
  }

  static round(number, precision) {
    const factor = Math.pow(10, precision);
    const tempNumber = number * factor;
    const roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  }

  static createGUID() {
    return Guid.create()["value"];
  }

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private explorerService: ExplorerService
  ) {
    explorerService.userRolesStream$.subscribe((response) => {
      this.rolePermission = response;
    });
    explorerService.userStream$.subscribe((responseUser) => {
      this.userRole = responseUser
        ? responseUser.roles[0]
          ? responseUser.roles[0].role.type
          : ""
        : "";
    });
  }

  static saveLocalStorage(obj: object) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        localStorage.setItem(key, obj[key]);
        sessionStorage.setItem(key, obj[key]);
      }
    }
    return;
  }

  isShowAdmin() {
    return this.userRole === "ROLE_ADMIN";
  }

  isShow(auth_number: string): boolean {
    // return true;
    let result = false;
    if (this.userRole === "ROLE_ADMIN" || this.userRole === "ROLE_SUPERVISOR") {
      return true;
    } else {
      if (this.rolePermission) {
        this.rolePermission.forEach((role) => {
          if (auth_number === role.auth_number) {
            result = true;
          }
        });
        return result;
      } else {
        return result;
      }
    }
  }

  static get dateFormatString() {
    return sessionStorage.getItem("dateFormatString");
  }

  hasProperty(object, findKey) {
    if (typeof object === "object") {
      return Object.keys(object).find((key) => key === findKey);
    } else {
      return false;
    }
  }

  alertErrorMessage(error: any, serviceLevel = true) {
    let message = "";
    if (error instanceof HttpErrorResponse && serviceLevel === true) {
      const responseError = error.error;
      if (error.status >= 400 && responseError) {
        if (error.status === 404) {
          message = responseError.path + " " + responseError.error;
        } else {
          if (responseError.hasOwnProperty("uimessage")) {
            message = responseError.uimessage[0]
              ? responseError.uimessage[0].text + "\n"
              : "";
            if (responseError.iomessage.length > 0) {
              message =
                message +
                (responseError.iomessage[1]
                  ? responseError.iomessage[1].text
                  : responseError.iomessage[0].text) +
                "\n";
            }
          } else if (responseError.hasOwnProperty("error_description")) {
            message =
              responseError.error_description === "Bad credentials"
                ? this.translateService.instant("bad_credentials")
                : this.translateService.instant("could_not_login");
          } else if (responseError.hasOwnProperty("exception")) {
            message = responseError.exception;
          } else {
            message = this.translateService.instant("untitled_error");
          }
        }
      } else {
        message = this.translateService.instant("could_not_connect_server");
      }
    } else {
      if (error.name === "HttpErrorResponse") {
        if (error.status === 400) {
          message = this.translateService.instant("Post edilen veri hatalı");
        } else {
          message = this.translateService.instant("could_not_connect_server");
        }
      } else {
        message = error.message ? error.message : error.toString();
      }
    }
    return message;
  }

  errorMaker(error: Error, serviceLevel = true) {
    let html;
    const context = Object.create(null);
    // EGER SERVISTEN BIR HATA GELIRSE
    if (error instanceof HttpErrorResponse && serviceLevel === true) {
      const responseError = error.error;
      if (error.status >= 400 && responseError) {
        if (responseError.hasOwnProperty("uimessage")) {
          context.uimessage = responseError.uimessage.map((err) => {
            return err.text;
          });
          context.iomessage = responseError.iomessage.map((err) => {
            return err.text;
          });
        } else if (responseError.hasOwnProperty("error_description")) {
          context.uimessage =
            responseError.error_description === "Bad credentials"
              ? this.translateService.instant("bad_credentials")
              : this.translateService.instant("could_not_login");
          context.iomessage = [context.uimessage];
        } else if (responseError.hasOwnProperty("exception")) {
          context.uimessage = responseError.exception;
          context.iomessage = [context.uimessage];
        } else {
          context.uimessage = this.translateService.instant("untitled_error");
          context.iomessage = [context.uimessage];
        }
      } else {
        context.uimessage = this.translateService.instant(
          "could_not_connect_server"
        );
        context.iomessage = [error.message];
      }
    } else {
      if (error.name === "HttpErrorResponse") {
        context.uimessage = this.translateService.instant(
          "could_not_connect_server"
        );
      } else {
        context.uimessage = [error.message ? error.message : error.toString()];
        context.iomessage = [error.stack];
      }
    }
    if (error.name === "HttpErrorResponse") {
      html = `<ul>
                ${context.uimessage}
            </ul>`;
    } else {
      html = `<ul>
                ${context.uimessage.join("")}
            </ul>
            ${
              context.iomessage.length
                ? '<label for="toggleCheckbox" id="toggleCheckboxLAbel">Hata detayları</label>' +
                  '<input type="checkbox" id="toggleCheckbox" class="toggle_checkbox">'
                : ""
            }
            <code>
                 <ul>
                    ${context.iomessage.join("")}
                </ul>
                <button class="btn btn-sm btn-default">${this.translateService.instant(
                  "send_report"
                )}</button>
            </code>
    `;
    }
    context.html = html;
    return context;
  }

  isPrimitive(t) {
    return (
      this.isString(t) ||
      this.isNumber(t) ||
      this.isBoolean(t) ||
      this.isDate(t)
    );
  }

  isString(t) {
    return "string" === typeof t;
  }

  isNullOrWhiteSpace(t) {
    return null == t || t.replace(/\s/g, "").length < 1;
  }

  isNumber(t) {
    return "number" === typeof t;
  }

  isInt(t) {
    return this.isNumber(t) && t === Math.round(t);
  }

  isBoolean(t) {
    return "boolean" === typeof t;
  }

  isFunction(t) {
    return "function" === typeof t;
  }

  isUndefined(t) {
    return void 0 === t;
  }

  isDate(t) {
    return (
      (t instanceof Date ||
        "[object Date]" === Object.prototype.toString.call(t)) &&
      !isNaN(t.getTime())
    );
  }

  isArray(t) {
    return (
      t instanceof Array ||
      Array.isArray(t) ||
      "[object Array]" === Object.prototype.toString.call(t)
    );
  }

  isObject(t) {
    return (
      null != t && "object" === typeof t && !this.isDate(t) && !this.isArray(t)
    );
  }

  isEmpty(t) {
    for (const e in t) {
      return !1;
    }
    return !0;
  }

  // parametre ile gelen 12 haneli barkoda check digit ekleyerek ean-13 tipli barkod'a dönüştürür
  generateCheckDigit(value) {
    let sumDigitDouble = 0;
    let sumDigitSingle = 0;
    let checkDigitValue = 0;

    let X1;
    let X2;
    let X3;
    let X4;
    let X5;
    let X6;
    let X7;
    let X8;
    let X9;
    let X10;
    let X11;
    let X12;

    if (value.length !== 12) {
      return value;
    }

    X1 = parseInt(value.substring(0, 1));
    X2 = parseInt(value.substring(1, 2));
    X3 = parseInt(value.substring(2, 3));
    X4 = parseInt(value.substring(3, 4));
    X5 = parseInt(value.substring(4, 5));
    X6 = parseInt(value.substring(5, 6));
    X7 = parseInt(value.substring(6, 7));
    X8 = parseInt(value.substring(7, 8));
    X9 = parseInt(value.substring(8, 9));
    X10 = parseInt(value.substring(9, 10));
    X11 = parseInt(value.substring(10, 11));
    X12 = parseInt(value.substring(11, 12));

    sumDigitDouble = X2 + X4 + X6 + X8 + X10 + X12;
    sumDigitSingle = X1 + X3 + X5 + X7 + X9 + X11;

    checkDigitValue = 10 - ((sumDigitDouble * 3 + sumDigitSingle) % 10);
    return checkDigitValue.toString();
  }

  base64ToBlob(base64, fileName) {
    base64 = window.atob(base64);
    const buffer = new ArrayBuffer(base64.length),
      view = new Uint8Array(buffer);
    for (let i = 0; i < base64.length; i++) {
      view[i] = base64.charCodeAt(i);
    }
    const zip = new JSZip(buffer);
    const file = zip.files[fileName];
    return new Promise((resolve, reject) => {
      if (file) {
        return resolve(file.asText());
      } else {
        return reject("File Not Allow");
      }
    });
  }

  deepCopy<T>(source: T): T {
    if (source === undefined) {
      return null;
    } else {
      return JSON.parse(JSON.stringify(source));
    }
  }

  get dateFormatString(): string {
    // return this.userEnvironment ? (this.userEnvironment.date_format ? this.userEnvironment.date_format : 'DD.MM.YYYY') : 'DD.MM.YYYY';
    return "DD.MM.YYYY";
  }

  selectedCompany(): any {
    // return this.userEnvironment ? (this.userEnvironment.company ? this.userEnvironment.company : {}) : {};
    return { id: 1 };
  }

  selectedWorkingPeriod(): any {
    // return this.userEnvironment ? (this.userEnvironment.working_period ? this.userEnvironment.working_period : {}) : {};
    return { id: 1 };
  }
}
